import React from 'react'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { formatDate } from '@ifca-root/react-component/src/helpers/StringNumberFunction/formatDate'
import { amtNumStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import { default as useUploadDocument } from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import { UsefulLifeDetailContent } from './UsefulLifeDetailContent'
import { UsefulLifeAdjustmentDetailContent } from './UsefulLifeAdjustmentDetailContent'

export const UsefulLifeDetail = (props: any) => {
  let history = useHistory()
  const { mode } = props
  const { CompanyID, UsefulLifeID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const editData = location?.state as any
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    clearErrors,
  } = useForm<any>()
  const [audioInput, setAudioInput] = useState('')
  const [record, setRecord] = useState(false)
  const [text, setText] = useState(mode === 'add' ? '' : editData?.remark)
  const [singleRemark, setSingleRemark] = useState(null)
  const handleSingleRemark = remark => {
    setSingleRemark(remark)
  }

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  let itemData = []
  itemData = editData?.UsefulLifeID

  const {
    files,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
    setFiles,
  } = useUploadDocument()

  const dummyData = [
    {
      ID: 1,
      Name: 'Computer pheripheral',
      AssetNo: 'A-000012',
      ModelNo: 'FA-MV-001',
      InitialValue: 60,
      UpdatedValue: 40,
      Description: 'Change description here',
      Date: '2021-05-27T12:44:01.162Z',
      ApprovalStatus: 'SUBMIT',
      SubmittedBy: 'Syima',
      SubmittedDate: '2021-05-27T12:44:01.162Z',
      ApprovedBy: 'Leong Koh',
      ApprovedDate: '2021-05-27T12:44:01.162Z',
      UsefulAdjustment: {
        DocumentDesc: 'Document description here',
        Reason: 'Reason here...',
      },
    },
  ]

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    error: getUsersByAccountAndSoftwareError,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftwareData: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const rejectFooterOption = {
    name: 'Reject',
    onClick: () => {
      setOpenRejectDialog(false)
    },
    color: 'secondary',
    props: { type: 'submit' },
  }

  const approveFooterOption = {
    name: 'Approve',
    onClick: () => {
      setOpenRejectDialog(false)
    },
    color: 'primary',
    props: { type: 'submit' },
  }
  const footerOptions: any[] = [rejectFooterOption, approveFooterOption]

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}/assets-change/useful-life`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Useful Life' },
        ]}
        rightRouteSegments={[{ name: 'Approved', current: true }]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>{dummyData[0]?.Name}</span>
          </span>
        }
        rightText={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>{dummyData[0]?.AssetNo}</span>
          </span>
        }
        infoLine={
          <div
            className="text-overflow"
            style={{ fontSize: '11px', width: '270px' }}
          >
            <span>
              {`Useful Life: `}
              <span style={{ textDecoration: 'line-through' }}>
                {`${amtNumStr(dummyData[0].InitialValue)}`}
              </span>
              <span style={{ color: 'orange' }}>&#10230;</span>
              <span style={{ color: 'limegreen' }}>{` ${amtNumStr(
                dummyData[0]?.UpdatedValue
              )}`}</span>
            </span>
          </div>
        }
        rightInfoLine={<span>{formatDate(dummyData[0]?.Date)}</span>}
      />

      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <UsefulLifeDetailContent
            listEl={dummyData[0]}
            listStatus={dummyData[0]?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>

        <CardContents
          section={{
            header: { title: 'Useful Life Adjustment' },
          }}
        >
          <UsefulLifeAdjustmentDetailContent listAdjustment={dummyData[0]} />
        </CardContents>
      </ContentWrapper>

      {mode === 'workdesk' ? <Footer options={[...footerOptions]} /> : null}

      {dummyData[0]?.ApprovalStatus === 'SUBMIT' ? (
        <Footer
          options={[
            {
              name: 'POST',
              onClick: () => {},
              color: 'primary',
            },
          ]}
        />
      ) : null}

      <RejectDialog
        data={dummyData[0]}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        audioInput={audioInput}
        record={record}
        setRecord={setRecord}
        setValue={setValue}
        errors={errors}
        register={register}
        control={control}
        clearErrors={clearErrors}
        setText={setText}
        handleSingleRemark={handleSingleRemark}
      />
    </>
  )
}
